export const PRISMA_LINK = 'https://prisma.onelink.me/CuJ7/cd2973e2'
